import React from 'react';
import { Grid, TextField } from '@material-ui/core';

export function ReadOnlyField({ label, value, xs = 12 }) {
    return (
        <Grid item xs={xs}>
            <TextField
                disabled
                label={label}
                fullWidth
                type="text"
                value={value || ''}
            />
        </Grid>
    );
}

export function EditableField({ label, value, onChange, disabled = false, required = false, xs = 12, type = 'text' }) {
    return (
        <Grid item xs={xs}>
            <TextField
                label={label}
                fullWidth
                required={required}
                type={type}
                disabled={disabled}
                value={value || ''}
                onChange={onChange}
            />
        </Grid>
    );
}

export function InfoDisplay({ label, value, xs = 12 }) {
    if (!value) return null;
    
    return (
        <Grid item xs={xs}>
            <b>{label}:</b> {value}
        </Grid>
    );
}